export enum LoaderType {
  FULL_SCREEN,
  EMBEDDED,
  INLINE,
  INLINE_TEXT,
}

export enum ToggleSwitchStatus {
  UNCHECKED = 'UNCHECKED',
  CHECKED = 'CHECKED',
  ACTIVE = 'ACTIVE',
}
